module.exports = __webpack_public_path__ + "public/img/International.e03c7f85.png";